import { Directive, Input } from '@angular/core';
import { NG_VALIDATORS, UntypedFormGroup, Validator } from '@angular/forms';

@Directive({
    selector: '[duplicateValueValidator]',
    providers: [
        {
            provide: NG_VALIDATORS,
            useExisting: DuplicateValueValidatorDirective,
            multi: true,
        },
    ],
    standalone: true,
})
export class DuplicateValueValidatorDirective implements Validator {
	@Input() duplicateValueValidator: Array<string> = [];

	validate(control: UntypedFormGroup): { [key: string]: any } | null {
		let anyErrors = false;
		if (control) {
			const controls = control.controls;
			this.duplicateValueValidator.forEach((controlPrefix) => {
				const keys = Object.keys(controls).filter((name) => name.startsWith(controlPrefix));
				const values = [];

				keys.forEach((key) => {
					const currentControl = controls[key];
					const value = currentControl.value?.toString().toLowerCase();
					values.push(value);
				});

				//Make two passes through the controls array so that the duplicate error shows on both controls, not just the second one
				keys.forEach((key) => {
					const currentControl = controls[key];
					const value = currentControl.value?.toString().toLowerCase();
					if (values.filter((v) => value === v).length > 1) {
						anyErrors = true;
						currentControl.setErrors({ duplicateValue: true });
					} else if (currentControl?.errors?.duplicateValue) {
						currentControl.setErrors(null);
						currentControl.updateValueAndValidity();
					}
				});
			});
		}
		return anyErrors ? { duplicateValue: true } : null;
	}
}
